import { Reply, SquarePlus } from "lucide-react"
import { Button } from "@/components/ui/button.tsx"
import { useNavigate } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

export const CreatePitchButton = ({
  withText = true,
  callId = "",
  className = "",
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const onClickCreate = async () => {
    await navigate({
      to: callId ? `/pitch/create?callId=${callId}` : "/pitch/create",
    })
  }

  return (
    <Button size="lg" className={className} onClick={onClickCreate}>
      {callId ? <Reply /> : <SquarePlus />}
      {withText && (callId ? t("replyCall") : t("createBtn"))}
    </Button>
  )
}
